import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import App from './App';
import Modal from 'react-modal';
import './styles/style.scss';

const MEASUREMENT_ID = "G-GJL5XV88C7"; 
ReactGA.initialize(MEASUREMENT_ID);

Modal.setAppElement(document.getElementById('root'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);